import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Check, X } from "lucide-react";

const ITEMS = [
  { id: "m_audit", label: "Migrations audit ativo", check: async () => {
    const { count } = await supabase.from("migrations_audit").select("*", { count: "exact", head: true });
    return (count ?? 0) >= 0;
  }},
  { id: "twelve_flags", label: "12 flags canônicas semeadas", check: async () => {
    const canonical = ["memory_hardening_v1","pattern_separation_enabled","memory_quarantine_enabled","threat_detector_enabled","metacognition_layer_enabled","group_state_enabled","conflict_pipeline_enabled","response_inhibitor_enabled","input_gating_v2","learning_loop_unified","interoceptive_lc_enabled","cortex_behavioral_kill"];
    const { data } = await supabase.from("feature_flags").select("flag_key").in("flag_key", canonical);
    return new Set(data?.map((d) => d.flag_key)).size === 12;
  }},
  { id: "kill_switches", label: "Kill-switches presentes", check: async () => {
    const { count } = await supabase.from("feature_flags").select("*", { count: "exact", head: true })
      .in("flag_key", ["cortex_global_kill", "cortex_behavioral_kill"]);
    return (count ?? 0) >= 2;
  }},
  { id: "rollback_events", label: "Tabela rollback_events ativa", check: async () => {
    const { error } = await supabase.from("rollback_events").select("id").limit(1);
    return !error;
  }},
  { id: "incidents_silenced", label: "Incidents silenced ativo", check: async () => {
    const { error } = await supabase.from("incidents_silenced").select("id").limit(1);
    return !error;
  }},
  { id: "group_state_trace", label: "Group state trace disponível", check: async () => {
    const { error } = await supabase.from("group_state_trace").select("trace_id").limit(1);
    return !error;
  }},
  { id: "telemetry", label: "Telemetria 11 CortexEvents", check: async () => {
    const { error } = await supabase.from("telemetry_events").select("event_type").limit(1);
    return !error;
  }},
];

export function InstallChecklist() {
  const { data: results = [], isLoading } = useQuery({
    queryKey: ["install-checklist"],
    queryFn: async () => Promise.all(ITEMS.map(async (i) => ({ ...i, ok: await i.check().catch(() => false) }))),
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>Checklist de Instalação (Doc 3 §15)</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {isLoading ? <p className="text-sm text-muted-foreground">Verificando…</p> : results.map((r) => (
          <div key={r.id} className="flex items-center justify-between border-b py-2 last:border-0">
            <span className="text-sm">{r.label}</span>
            {r.ok ? (
              <Check className="w-5 h-5 text-primary" />
            ) : (
              <X className="w-5 h-5 text-destructive" />
            )}
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
